import { render, staticRenderFns } from "./SpecialBiwako202402.vue?vue&type=template&id=16bf28dc&scoped=true"
import script from "./SpecialBiwako202402.vue?vue&type=script&lang=js"
export * from "./SpecialBiwako202402.vue?vue&type=script&lang=js"
import style0 from "./SpecialBiwako202402.vue?vue&type=style&index=0&id=16bf28dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf28dc",
  null
  
)

export default component.exports